import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Commentaire } from "src/app/core/models/Commentaire";

@Component({
	selector: "app-comments",
	templateUrl: "./comment.component.html",
})
export class CommentListComponent implements OnInit {
	@Input() isShownComment: boolean = true;
	@Input() comments: Commentaire[];
	@Input() hiddenForm: false;
	@Output() addComment = new EventEmitter();
    @Input() isFullHeight: boolean = true;
	form: FormGroup;
	formControlle: FormControl;
	constructor(private fb: FormBuilder) {
		this.form = this.fb.group({
			commentaireForm: this.fb.group({
				message: ["", Validators.required],
			}),
		});
	}

	ngOnInit() {}

	get commentairesForm() {
		return this.form.get("commentaireForm") as FormGroup;
	}
	public onAddCommentaire() {
		//const newComment = this.createFormComment(this.commentairesForm.get("message").value);
		this.addComment.emit(this.commentairesForm.get("message").value);
		this.resetFormComment();
	}
	private createFormComment(message: string): FormGroup {
		return this.fb.group({
			message: [message],
		});
	}
	private initialisedFormComments(comments: any[]) {}
	private resetFormComment() {
		this.commentairesForm.get("message").setValue("");
	}
}
